import { render, staticRenderFns } from "./copy-form-from-modal.vue?vue&type=template&id=081c81de&scoped=true&"
import script from "./copy-form-from-modal.vue?vue&type=script&lang=js&"
export * from "./copy-form-from-modal.vue?vue&type=script&lang=js&"
import style0 from "./copy-form-from-modal.vue?vue&type=style&index=0&id=081c81de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c81de",
  null
  
)

export default component.exports